module.exports = __webpack_public_path__ + "static/media/menu-dark.7a83d70a.svg";